// Columnas de la plantilla de migración (spec 2026-10-14 §2 D5). Fuente única: la usan
// el generador de la plantilla y el lector del archivo, así nunca divergen.

export const HEADERS = [
  'Ruta de proceso',
  'Nombres de proceso',
  'Tipo de documento',
  'Nombre del tipo',
  'Frecuencia del tipo (días)',
  'Código',
  'Nombre',
  'Origen',
  'Estado',
  'Versión actual',
  'Revisión',
  'Fecha de vigencia',
  'Fecha de aprobación',
  'Frecuencia propia (días)',
  'Normas',
  'Dueño',
  'Elaborador',
  'Revisor',
  'Aprobador',
  'Capacitador',
];

export const REQUIRED_HEADERS = [
  'Ruta de proceso',
  'Tipo de documento',
  'Código',
  'Versión actual',
];

export const ROLE_COLUMNS = [
  ['Elaborador', 'elaborador'],
  ['Revisor', 'revisor'],
  ['Aprobador', 'aprobador'],
  ['Capacitador', 'capacitador'],
] as const;

export const STATUS_BY_LABEL: Record<string, string> = {
  reservado: 'reservado',
  borrador: 'borrador',
  'en revisión': 'en_revision',
  'en aprobación': 'en_aprobacion',
  vigente: 'vigente',
  obsoleto: 'obsoleto',
};

export const ORIGIN_BY_LABEL: Record<string, string> = { interno: 'interno', externo: 'externo' };

/** Qué va en cada columna (hoja "Instrucciones" de la plantilla). */
export const HELP: Record<string, string> = {
  'Ruta de proceso':
    'Obligatoria. Códigos del proceso desde la raíz, separados por "/" (ej. GC / AUD). Los que no existan se crean.',
  'Nombres de proceso':
    'Un nombre por cada código de la ruta, en el mismo orden y separados por "/" (ej. Gestión de Calidad / Auditoría). Sirven para crear los procesos que falten.',
  'Tipo de documento': 'Obligatoria. Código del tipo (ej. PR, MA, FR).',
  'Nombre del tipo': 'Nombre del tipo, si hay que crearlo.',
  'Frecuencia del tipo (días)': 'Cada cuántos días se revisa el tipo, si hay que crearlo.',
  Código: 'Obligatoria. Código único del documento (no se reutilizan códigos).',
  Nombre: 'Nombre del documento.',
  Origen: 'Interno o Externo. Si se deja vacío: Interno.',
  Estado:
    'Reservado, Borrador, En revisión, En aprobación, Vigente u Obsoleto. Si se deja vacío: Vigente.',
  'Versión actual': 'Obligatoria. Versión en la que va el documento hoy (ej. 4); no empieza en 1.',
  Revisión:
    'Etiqueta de revisión tal como la usan hoy (ej. 4.5, Rev C). Dale formato de texto a la columna para que Excel no la convierta en fecha.',
  'Fecha de vigencia': 'DD/MM/AAAA. Para los vigentes arranca el reloj de la próxima revisión.',
  'Fecha de aprobación': 'DD/MM/AAAA.',
  'Frecuencia propia (días)': 'Solo si este documento se revisa con otra frecuencia que su tipo.',
  Normas: 'Norma y cláusula, separadas por punto y coma (ej. ISO 9001 8.6; BPADIS L-14).',
  Dueño: 'Correo de la persona dueña del documento.',
  Elaborador:
    'Correos de personas o códigos de puesto del LMS, separados por punto y coma (;) o en líneas distintas de la celda. La persona debe tener acceso al QMS en la empresa.',
  Revisor: 'Igual que Elaborador.',
  Aprobador: 'Igual que Elaborador.',
  Capacitador: 'Igual que Elaborador.',
};
